import {registerCrudStore} from '@/libs/core/+state/register-crud-store';
import {VerificationsDataService} from '@/libs/verification/verifications-data-service';
import {BusinessModule} from '@/libs/core/models/business-module';
import { MeasureModel } from '@/libs/Api';

export const verificationsStore = registerCrudStore<MeasureModel, MeasureModel>(BusinessModule.Verification, new VerificationsDataService());
